import type { RuleHandler } from "../types";

const checkExcludeLiveMarkets: RuleHandler = (context, requirement) => {
  if (
    requirement.userDrivenAttributes?.excludeLiveMarkets &&
    context.selection.hasLiveMarkets
  ) {
    return false;
  }

  return true;
};

export { checkExcludeLiveMarkets };
